import Vue from 'vue'
import Router from 'vue-router'
const HomePage = r => require.ensure([],() => r(require('@/pages/homePage')),'HomePage')
const AboutUs = r => require.ensure([],() => r(require('@/pages/aboutUs')),'AboutUs')
const ServeProducts = r => require.ensure([],() => r(require('@/pages/serveProducts')),'ServeProducts')
const LatestNews = r => require.ensure([],() => r(require('@/pages/latestNews')),'LatestNews')
const ContactUs = r => require.ensure([],() => r(require('@/pages/contactUs')),'ContactUs')
const Details = r => require.ensure([],() => (require('@/pages/details')),'Details')
const MenuDetails = r => require.ensure([],() => (require('@/pages/MenuDetails')),'MenuDetails')
const ArticleDetail = r => require.ensure([],() => (require('@/pages/articleDetail')),'ArticleDetail')
const Examples = r => require.ensure([],() => (require('@/pages/examples')),'Examples')

Vue.use(Router)
const VueRouterPush = Router.prototype.push 
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/ServeProducts',
      name: 'ServeProducts',
      component: ServeProducts
    },
    {
      path: '/LatestNews',
      name: 'LatestNews',
      component: LatestNews
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/Details',
      name: 'Details',
      component: Details
    },
    {
      path: '/MenuDetails',
      name: 'MenuDetails',
      component: MenuDetails
    },
    {
      path: '/ArticleDetail',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/Examples',
      name: 'Examples',
      component: Examples
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js